import { Root } from '@radix-ui/react-hover-card'
import type { ComponentProps, JSX } from 'react'

export type HoverCardProps = ComponentProps<typeof Root>

export function HoverCard(props: HoverCardProps): JSX.Element {
  return <Root {...props} />
}
